module.exports = __webpack_public_path__ + "img/icon_plan_lightgray.282a192c.svg";